import { Button, Text } from '@kanda-libs/ks-design-library';
import { Company } from '@kanda-libs/ks-frontend-services';

import FinanceCalculatorLinkModal from './Modal';
import useFinanceCalculatorLink from './useFinanceCalculatorLink';

import { CLASS_NAMES } from '../../constants';

export interface FinanceCalculatorLinkProps {
  company?: Company;
}

const FinanceCalculatorLink: React.FunctionComponent<FinanceCalculatorLinkProps> =
  function ({ company }) {
    const { onClick } = useFinanceCalculatorLink();
    if (!company) return null;
    return (
      <>
        <Text text="Configure Calculator Link" className={CLASS_NAMES.title} />
        <Button.Text
          id="change-deposit-state"
          onClick={onClick}
          label="Get Finance Calculator Link"
          size={40}
          className="mb-4"
        />
        <FinanceCalculatorLinkModal />
      </>
    );
  };

export default FinanceCalculatorLink;
